import { Box, Stack, Typography, TypographyProps } from "@mui/material";
import Calendar from "components/Calendar";
import { TruncateTypography } from "components/TruncateTypography";
import { TasksQuery, VirtualEventStatus } from "generated-graphql/graphql";

import { virtualEventStatusToIcon } from "./statusStyles";
import { buildBeforeAfterSearchString } from "./util.buildSearchString";

export const TasksCalendar = ({
  loading,
  tasks,
  onTaskClick,
  onRangeChange,
}: {
  loading: boolean;
  tasks: TasksQuery["virtualEvents"]["items"];
  onTaskClick: (task: TasksQuery["virtualEvents"]["items"][0]) => void;
  onRangeChange: (range: string) => void;
}) => {
  return (
    <Calendar
      sx={{ pb: 4 }}
      loading={loading}
      events={tasks}
      onEventClick={onTaskClick}
      onMonthChange={(month) => onRangeChange(buildBeforeAfterSearchString(month))}
      renderEventChip={(item, truncate = true) => {
        if (truncate) {
          return (
            <Stack
              sx={{ cursor: "pointer" }}
              direction="row"
              alignItems="center"
              spacing={0.5}
              overflow="hidden"
              onClick={() => onTaskClick(item)}
            >
              {virtualEventStatusToIcon(item.status)}
              <TruncateTypography variant="caption" color={statusToTextColor(item.status)}>
                {item.title}
              </TruncateTypography>
            </Stack>
          );
        }
        return (
          <Stack
            sx={{ cursor: "pointer" }}
            direction="row"
            alignItems="center"
            spacing={0.5}
            onClick={() => onTaskClick(item)}
          >
            <Stack direction="row" height="100%">
              <Box sx={{ height: "1rem", marginTop: "-1px", marginRight: 0.5 }}>
                {virtualEventStatusToIcon(item.status)}
              </Box>
              <Typography variant="caption" color={statusToTextColor(item.status)}>
                {item.title}
              </Typography>
            </Stack>
          </Stack>
        );
      }}
    />
  );
};

const statusToTextColor = (status: VirtualEventStatus): TypographyProps["color"] => {
  switch (status) {
    case VirtualEventStatus.Active:
      return "textSecondary";
    case VirtualEventStatus.Overdue:
      return "error";
    case VirtualEventStatus.Completed:
      return "textDisabled";
  }
};
